module.exports = __webpack_public_path__ + "static/media/slide-6.bc83907e.jpg";